import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  IconButton,
  useMediaQuery,
} from "@chakra-ui/react";
import Thread from "components/tweets/masonry/thread";
import { cancelPostPublishActions } from "controllers/schedule";
import { hasAdvancedOptions } from "utils/tweetUtils";
import { DialogBox } from "components/collaboration/dialog-box";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FiShare2 } from 'react-icons/fi';
import toast from "react-hot-toast";
import { PlusIcon } from "components/icons/PlusIcon";
import { layerStyle } from "theme/names";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  tweet: any;
  hideAdvancedButton?: boolean
  isGhostwriter?: boolean
  showAddToQueue?: boolean
  handleAddToQueue: () => void;
}

export function SettingsPopup({ isOpen, onClose, tweet, hideAdvancedButton = false,
  isGhostwriter = false,
  showAddToQueue = false,
  handleAddToQueue = () => { },
}: Props) {
  const [isCancelling, setIsCancelling] = useState<boolean>(false);
  const [isAddingToQueue, setIsAddingToQueue] = useState<boolean>(false);
  const threadTweets = tweet.text?.split("\n\n\n");
  const [activeAdvancedOptions] = hasAdvancedOptions(tweet);

  const [isTooSmall] = useMediaQuery("(max-width: 1000px)");

  let enableCollaboration = !!tweet.ghostwriterId && !isTooSmall;
  let collaborationWidth = "448px";


  return (
    <Modal isOpen={isOpen} onClose={onClose} returnFocusOnClose={false} >
      <ModalOverlay />
      <ModalContent mr={enableCollaboration ? collaborationWidth : 0} pb="3" position="relative">
        <ModalHeader>Your Tweet</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {threadTweets && (
            <Box display="flex" justifyContent="center">
              <Thread
                threadTweets={threadTweets}
                disableNbChar={true}
                tweet={tweet}
                showOutline={true}
                disablePreview={tweet?.isPreventLinkExpand}
                image={tweet?.image ?? tweet?.profilePic}
                showGenerateImage={false}
              />
            </Box>
          )}
          {
            isTooSmall && tweet.ghostwriterId && (
              <Box mt={0} bg={"white"} p={5} rounded="md" w={"100%"} layerStyle={layerStyle["bg.border.rounded"]}>
                <DialogBox tweet={tweet} isGhostwriter={isGhostwriter} onClose={onClose} />
              </Box>
            )
          }
        </ModalBody>

        {
          tweet.ghostwriterId && !isTooSmall && (
            <Box position="fixed" left="calc(50vw + 20px)" top={"60px"} bg={"white"} p={5} rounded="md" w={collaborationWidth} zIndex={1500} layerStyle={layerStyle["bg.border.rounded"]}>
              <DialogBox tweet={tweet} isGhostwriter={isGhostwriter} onClose={onClose} />
            </Box>
          )
        }
        <ModalFooter mb={2}>
          <Button variant="tertiary" onClick={onClose} mr={3}>Cancel</Button>
          {!hideAdvancedButton && activeAdvancedOptions && (
            <Button
              variant={"secondaryDestructive"}
              colorScheme="red"
              onClick={async () => {
                setIsCancelling(true);
                await cancelPostPublishActions(tweet);
                setIsCancelling(false);
                onClose();
              }}
              isLoading={isCancelling}
            >
              Cancel all advanced options
            </Button>
          )}
          {
            showAddToQueue && (
              <Button
                variant={"primary"}
                isLoading={isAddingToQueue}
                onClick={async (e) => {
                  setIsAddingToQueue(true);
                  e.stopPropagation();
                  handleAddToQueue && await handleAddToQueue();
                  setIsAddingToQueue(false);
                }}
                leftIcon={PlusIcon}
              >
                Add To Queue
              </Button>
            )
          }
          {
            !!tweet?.id && (
              <CopyToClipboard
                text={"https://tweethunter.io/public?id=" + tweet.id}
                onCopy={() => {
                  toast.success("Public url copied to clipboard", {
                    style: {
                      background: "gray.600",
                      color: "#222",
                    },
                  });
                }}
              >
                <IconButton
                  variant="secondary"
                  ml={4}
                  // size="sm"
                  aria-label="GitHub"
                  icon={<FiShare2 fontSize="16px" />}
                />
              </CopyToClipboard>
            )
          }
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
